import { cn } from "@/shared/lib/utils";

interface BotanicalPatternProps {
  className?: string;
}

/**
 * Patrón decorativo orgánico. SVG inline con hojas abstractas (no literal
 * — abstracción de ramas, no "leaf clipart"). Hereda color de
 * `currentColor` para que el consumidor controle tono + opacity con
 * utilities Tailwind.
 *
 * Pensado para capas decorativas en fondos grandes (panel brand del
 * AuthLayout, hero del Dashboard, etc.). Siempre `aria-hidden`.
 */
export function BotanicalPattern({ className }: BotanicalPatternProps) {
  return (
    <svg
      aria-hidden
      viewBox="0 0 800 1000"
      preserveAspectRatio="xMidYMid slice"
      className={cn("pointer-events-none select-none", className)}
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      {/* Rama 1 — curva larga que sube desde abajo-izquierda. */}
      <g strokeWidth="1.2">
        <path d="M -40 980 C 120 820, 180 680, 220 520 C 250 400, 240 300, 280 200 C 310 120, 360 60, 420 20" />
        {/* Hojas ovaladas abstractas. */}
        <ellipse cx="180" cy="760" rx="38" ry="12" transform="rotate(-25 180 760)" />
        <ellipse cx="230" cy="640" rx="42" ry="13" transform="rotate(-15 230 640)" />
        <ellipse cx="250" cy="500" rx="36" ry="11" transform="rotate(10 250 500)" />
        <ellipse cx="245" cy="380" rx="40" ry="12" transform="rotate(-20 245 380)" />
        <ellipse cx="275" cy="260" rx="34" ry="10" transform="rotate(25 275 260)" />
      </g>

      {/* Rama 2 — descendente desde arriba-derecha, cruza en diagonal. */}
      <g strokeWidth="1" opacity="0.75">
        <path d="M 820 -20 C 700 100, 640 220, 600 360 C 570 480, 580 580, 540 700 C 500 820, 420 920, 300 980" />
        <ellipse cx="660" cy="180" rx="32" ry="10" transform="rotate(55 660 180)" />
        <ellipse cx="610" cy="320" rx="36" ry="11" transform="rotate(40 610 320)" />
        <ellipse cx="590" cy="460" rx="30" ry="9" transform="rotate(-30 590 460)" />
        <ellipse cx="560" cy="600" rx="34" ry="10" transform="rotate(60 560 600)" />
        <ellipse cx="510" cy="740" rx="28" ry="9" transform="rotate(45 510 740)" />
      </g>

      {/* Rama 3 — pequeña, delicada, centro-derecha. */}
      <g strokeWidth="0.8" opacity="0.55">
        <path d="M 440 420 C 480 440, 520 460, 560 500 C 590 530, 610 570, 630 620" />
        <ellipse cx="500" cy="450" rx="22" ry="7" transform="rotate(30 500 450)" />
        <ellipse cx="560" cy="500" rx="24" ry="7" transform="rotate(50 560 500)" />
        <ellipse cx="610" cy="580" rx="20" ry="6" transform="rotate(70 610 580)" />
      </g>

      {/* Semillas / puntos — micro-ritmo. */}
      <g fill="currentColor" opacity="0.6" stroke="none">
        <circle cx="140" cy="860" r="2.5" />
        <circle cx="200" cy="880" r="1.8" />
        <circle cx="700" cy="100" r="2" />
        <circle cx="750" cy="140" r="2.6" />
        <circle cx="400" cy="920" r="1.6" />
        <circle cx="460" cy="950" r="2.2" />
      </g>
    </svg>
  );
}
